import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import "./style.css";
import About from "./components/About";
import Blogs from "./components/Blogs";
import Resume from './components/Resume';
import BlogPost from "./components/BlogPost";
import Home from "./components/Home";
import ProgressBar from "./components/ProgressBar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { ThemeProvider, useTheme } from './context/ThemeContext';

function NavBar() {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <nav>
      <div className="nav-links">
        <Link to="/" style={{ color: 'white', fontSize: '18px' }}>Home</Link>
        <Link to="/about" style={{ color: 'white', fontSize: '18px' }}>About</Link>
        <Link to="/blogs" style={{ color: 'white', fontSize: '18px' }}>Blogs</Link>
        <Link to="/resume" style={{ color: 'white', fontSize: '18px' }}>Resume</Link>
      </div>
      <button
        onClick={toggleTheme}
        className="theme-toggle"
        aria-label="Toggle theme"
      >
        <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} size="lg" />
      </button>
    </nav>
  );
}

function AppContent() {
  return (
    <div>
      <ProgressBar />
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/blogs" element={<Blogs/>} />
        <Route path="/blogs/:blogTitle" element={<BlogPost />} />
      </Routes>
      <footer>
        <p>&copy; Ubaid R Butt. All Rights Reserved.</p>
        <div className="social-links">
          <a href="https://www.linkedin.com/in/ubaidbutt/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
          </a>
          <a href="https://github.com/Ubaidbutt" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faGithub} className="social-icon" />
          </a>
          <a href="https://www.instagram.com/ubaidbutt/" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} className="social-icon" />
          </a>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </Router>
  );
}

export default App;
